__turbopack_context__.v({
  "FullHeight": "Loading-module-sass-module__PuA7Pa__FullHeight",
  "Loading": "Loading-module-sass-module__PuA7Pa__Loading",
});
